import React from 'react';
import ShimmerEffect from './ShimmerEffect';

const CarouselItemSkeleton: React.FC = () => {
  return (
    <ShimmerEffect>
      <div className="card p-6 hover:scale-105 transition-transform h-full max-w-sm mx-auto bg-white">
        {/* Header with avatar and title */}
        <div className="flex items-start space-x-4 mb-4">
          <div className="w-16 h-16 rounded-full bg-gray-200 flex-shrink-0"></div>
          <div className="flex-1">
            <div className="flex items-center space-x-2 mb-2">
              <div className="h-5 w-32 bg-gray-200 rounded"></div>
              <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
            </div>
            <div className="flex items-center text-sm text-gray-600 mt-1">
              <div className="w-4 h-4 bg-gray-200 rounded mr-1"></div>
              <div className="h-4 w-12 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>

        {/* Info section */}
        <div className="space-y-2 text-sm mb-4">
          {/* Location */}
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0"></div>
            <div className="h-4 w-40 bg-gray-200 rounded"></div>
          </div>

          {/* Subject/Award */}
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0"></div>
            <div className="h-4 w-32 bg-gray-200 rounded"></div>
          </div>

          {/* Experience (optional) */}
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-gray-200 rounded flex-shrink-0"></div>
            <div className="h-4 w-28 bg-gray-200 rounded"></div>
          </div>

          {/* Price */}
          <div className="flex items-center space-x-1 font-semibold text-base mt-3">
            <div className="w-5 h-5 bg-gray-200 rounded"></div>
            <div className="h-5 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* Button */}
        <div className="w-full h-10 bg-gray-200 rounded mt-4"></div>
      </div>
    </ShimmerEffect>
  );
};

export default CarouselItemSkeleton;
